import React from 'react';

import {Benefits, HeaderVideo, JoinTeam, Social} from '../../components';
import {HomeServices} from '../../components/HomeServices';
import { ReactComponent as AssuranceIcon } from '../../assets/images/icon/AssuranceIcon.svg';
import benefitsAssuranceImg from '../../assets/images/benefits-assurance.jpg';


export const Home = () => (
  <>
    <HeaderVideo />
    <Benefits />
    <div className='assuranceBlock'>
      <div className="container">
        <div className="assuranceBlock__wrapper">
          <div className="assuranceBlock__block">
            <div className="assuranceBlock__icon"><AssuranceIcon /></div>
            <h2 className="assuranceBlock__title">Assurance</h2>
            <p className="assuranceBlock__desc">Equipped with a modern fleet and supported by a team of highly skilled mechanics, our company places a strong emphasis on preventive maintenance. This proactive strategy significantly reduces the likelihood of mechanical failures, thereby ensuring consistent operational reliability and the timely delivery of our goods.</p>
          </div>
          <div className="assuranceBlock__image" >
            <img src={benefitsAssuranceImg} alt="truck-image" />
          </div>
        </div>
      </div>
    </div>
    <JoinTeam />
    <HomeServices />
    <Social />
  </>
);
